function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.797 1.725l5.25 9.122a1.04 1.04 0 01-.919 1.553H1.65c-.81 0-1.312-.875-.919-1.553l5.25-9.122c.394-.7 1.422-.678 1.816 0z",
  fill: "#EE921A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.178 8.134l-.153-2.45c0-.153.11-.284.263-.284H7.49c.153 0 .262.131.262.284L7.6 8.134c0 .132-.131.241-.262.241H6.44c-.153 0-.263-.087-.263-.24zM6.9 8.681c.503 0 .919.416.919.919a.91.91 0 01-.919.919.897.897 0 01-.919-.919.91.91 0 01.92-.919z",
  fill: "#fff"
});

var SvgCaution = function SvgCaution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgCaution;